import { eventsDictType } from 'src/types/analytics/analytics';

export const eventsDict: eventsDictType = {
  defaultNav: {
    eventType: 'default_navigation',
    screenName: '',
    actionType: 'default_navigation',
    eventDate: new Date(),
    parameter: '',
    target: ['roxcode', 'cn_firebase'],
    otherData: {
      description: 'Navegou de uma tela para outra',
    },
  },
  authError: {
    eventType: 'auth_error',
    screenName: 'expired_session',
    actionType: 'auth_error',
    eventDate: new Date(),
    parameter: 'expired_session',
    target: ['roxcode'],
    otherData: {
      description: 'Usuário acessou a tela de sessão expirada',
    },
  },
  onboardingNav: {
    eventType: 'navigation',
    screenName: 'onboarding',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: 'onboarding_inicio_1',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu a primeira tela do onboarding',
    },
  },
  onboardingNext: {
    eventType: 'action',
    screenName: 'onboarding',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => `onboarding_funil_${param}`,
    target: ['roxcode'],
    otherData: {
      description: 'Toque para avançar',
    },
  },
  onboardingPrevious: {
    eventType: 'action',
    screenName: 'onboarding',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => `onboarding_drop_${param}`,
    target: ['roxcode'],
    otherData: {
      description: 'Toque para cancelar',
    },
  },
  homeNavOnboarding: {
    eventType: 'navigation',
    screenName: 'home',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: 'onboarding',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu home a partir do onboarding',
    },
  },
  homeNavSuperapp: {
    eventType: 'navigation',
    screenName: 'home',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: 'superapp',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu home a partir do superapp',
    },
  },
  homeNavStart: {
    eventType: 'navigation',
    screenName: 'home',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => `inicio_${param}`,
    target: ['roxcode'],
    otherData: {
      description: 'Abriu home de qualquer lugar do Viva pelo "Início" no topo',
    },
  },
  homeNavBar: {
    eventType: 'navigation',
    screenName: 'home',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => `navbar_${param}`,
    target: ['roxcode'],
    otherData: {
      description: 'Abriu home de qualquer lugar do Viva pela navigation bar inferior',
    },
  },
  homeMyViva: {
    eventType: 'action',
    screenName: 'home',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'meu_viva',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em "Meu Viva" na barra superior',
    },
  },
  homePoints: {
    eventType: 'action',
    screenName: 'home',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'pontos',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em "Pontos" na barra superior',
    },
  },
  homeExit: {
    eventType: 'action',
    screenName: 'home',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'sair_do_viva',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em "Sair do Viva" na barra superior',
    },
  },
  homeBanner: {
    eventType: 'action',
    screenName: 'home',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => `banner_position${param}`,
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em alguma posição do carrossel de banner',
    },
  },
  homeMyLevel: {
    eventType: 'action',
    screenName: 'home',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'meu_nivel',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em "Meu Nível"',
    },
  },
  homeToMyPointsList: {
    eventType: 'action',
    screenName: 'home',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'VivaHomeToMyLevel',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou no card de nível da Home',
    },
  },
  homeBenefitItem: {
    eventType: 'action',
    screenName: 'home',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => `benefícios_${param}`,
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em algum dos itens do carrossel de Benefícios',
    },
  },
  homePointsItem: {
    eventType: 'action',
    screenName: 'home',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => `acumular_${param}`,
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em algum dos itens do carrossel de Acumular Pontos',
    },
  },
  homeEventsItem: {
    eventType: 'action',
    screenName: 'home',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => `eventos_${param}`,
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em algum dos itens do carrossel de Eventos',
    },
  },
  myVivaNav: {
    eventType: 'navigation',
    screenName: 'meu_viva',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: 'home',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu "Meu Viva" a partir da home',
    },
  },
  myVivaMyDataIcon: {
    eventType: 'action',
    screenName: 'meu_viva',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'icon_dados_cadastrais',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou no ícone de edição que leva a Meus Dados',
    },
  },
  myVivaWallet: {
    eventType: 'action',
    screenName: 'meu_viva',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'carteirinha',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em "Carteirinha"',
    },
  },
  myVivaMyTrades: {
    eventType: 'action',
    screenName: 'meu_viva',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'minhas_trocas',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em "Minhas Trocas"',
    },
  },
  myVivaMyLevel: {
    eventType: 'action',
    screenName: 'meu_viva',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'meu_nivel',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em "Meu Nível"',
    },
  },
  myVivaMyInterests: {
    eventType: 'action',
    screenName: 'meu_viva',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'meus_interesses',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em "Meus Interesses"',
    },
  },
  myVivaMyData: {
    eventType: 'action',
    screenName: 'meu_viva',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'dados_cadastrais',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em "Dados Cadastrais"',
    },
  },
  myVivaMissions: {
    eventType: 'action',
    screenName: 'meu_viva',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'missoes',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em "Missões"',
    },
  },
  myVivaHelp: {
    eventType: 'action',
    screenName: 'meu_viva',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'ajuda',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em "Ajuda"',
    },
  },
  myVivaMyPoints: {
    eventType: 'action',
    screenName: 'meu_viva',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'MyVivaToMyLevel',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em "Meus Pontos" na tela Meu Viva',
    },
  },
  pointsNav: {
    eventType: 'navigation',
    screenName: 'pontos',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => `pontos_${param}`,
    target: ['roxcode'],
    otherData: {
      description: 'Abriu "Pontos" de qualquer lugar do Viva pelo "Pontos" no topo',
    },
  },
  pointsHistory: {
    eventType: 'navigation',
    screenName: 'pontos',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'historico_pontos',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu "Histórico de Pontos"',
    },
  },
  pointsInvoices: {
    eventType: 'navigation',
    screenName: 'pontos',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'minhas_notas',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu "Minhas notas"',
    },
  },
  pointsHowToUse: {
    eventType: 'navigation',
    screenName: 'pontos',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'como_usar',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu "Como usar pontos"',
    },
  },
  pointsHowToEarn: {
    eventType: 'navigation',
    screenName: 'pontos',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'como_ganhar',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu "Como ganhar pontos"',
    },
  },
  benefitsNav: {
    eventType: 'navigation',
    screenName: 'beneficios',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: (param: string) => `beneficios_${param}`,
    target: ['roxcode'],
    otherData: {
      description: 'Abriu Benefícios de qualquer lugar do Viva',
    },
  },
  benefitsHighlight: {
    eventType: 'action',
    screenName: 'beneficios',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: (param: string, secondParam: string) => `carrossel_${param}_${secondParam}`,
    target: ['roxcode'],
    otherData: {
      description: 'Abriu detalhes do item a partir do carrossel em destaque',
    },
  },
  benefitsList: {
    eventType: 'action',
    screenName: 'beneficios',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: (param: string, secondParam: string) => `detalhes_${param}_${secondParam}`,
    target: ['roxcode'],
    otherData: {
      description: 'Abriu detalhes do item a partir da listagem',
    },
  },
  benefitsRedeem: {
    eventType: 'action',
    screenName: 'beneficios',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: (param: string, secondParam: string) => `resgate_${param}_${secondParam}`,
    target: ['roxcode'],
    otherData: {
      description: 'Interagiu com o CTA nos detalhes do item',
    },
  },
  benefitsRedeemSuccess: {
    eventType: 'action',
    screenName: 'beneficios',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: (param: string, secondParam: string) => `sucesso_${param}_${secondParam}`,
    target: ['roxcode'],
    otherData: {
      description: 'Resgatou o item com sucesso',
    },
  },
  trailFinalRewardView: {
    eventType: 'action',
    screenName: 'trilha_de_conquistas',
    actionType: 'view',
    eventDate: new Date(),
    parameter: (param: string) => `premio_final_visualizacao_${param}`,
    target: ['roxcode', 'cn_firebase'],
    otherData: {
      description: 'Visualizou o prêmio final liberado da Trilha de Conquistas',
    },
  },
  trailFinalRewardClick: {
    eventType: 'action',
    screenName: 'trilha_de_conquistas',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => `premio_final_clique_${param}`,
    target: ['roxcode', 'cn_firebase'],
    otherData: {
      description: 'Iniciou o resgate do prêmio final da Trilha de Conquistas',
    },
  },
  trailSpecificBenefitClick: {
    eventType: 'action',
    screenName: 'trilha_de_conquistas',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string, secondParam: string) =>
      `resgate_beneficio_especifico_${param}_${secondParam}`,
    target: ['roxcode', 'cn_firebase'],
    otherData: {
      description: 'Abriu o benefício específico associado à etapa da trilha',
    },
  },
  invoicesOnboarding: {
    eventType: 'navigation',
    screenName: 'scan_nota',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: 'onboarding',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu scan de nota',
    },
  },
  invoicesModal: {
    eventType: 'navigation',
    screenName: 'scan_nota',
    actionType: 'modal',
    eventDate: new Date(),
    parameter: 'modal_sdk',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu scan de nota',
    },
  },
  invoicesClick: {
    eventType: 'navigation',
    screenName: 'scan_nota',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => param,
    target: ['roxcode'],
    otherData: {
      description: 'Abriu scan de nota',
    },
  },
  invoicesClose: {
    eventType: 'navigation',
    screenName: 'scan_nota',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: 'close_sdk',
    target: ['roxcode'],
    otherData: {
      description: 'Fechou scan de nota',
    },
  },
  walletMyViva: {
    eventType: 'navigation',
    screenName: 'carteirinha',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: 'meu_viva',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu carteirinha pelo Meu Viva',
    },
  },
  walletMenu: {
    eventType: 'navigation',
    screenName: 'carteirinha',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: 'menu',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu carteirinha pelo Menu',
    },
  },
  walletMyLevel: {
    eventType: 'action',
    screenName: 'carteirinha',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'meu_nivel',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou em "Meu nível"',
    },
  },
  qrCode: {
    eventType: 'action',
    screenName: 'carteirinha',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: (param: string) => param,
    target: ['roxcode'],
    otherData: {
      description: 'Teve o QR Code lido',
    },
  },
  myDataMenu: {
    eventType: 'navigation',
    screenName: 'meus_dados',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: 'menu',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu Meus Dados a partir do Menu',
    },
  },
  myDataMyVivaIcon: {
    eventType: 'navigation',
    screenName: 'meus_dados',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: 'icon_meu_viva',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu Meus Dados a partir do ícone em Meu Viva',
    },
  },
  myDataMyViva: {
    eventType: 'navigation',
    screenName: 'meus_dados',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: 'dados_meu_viva',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu Meus Dados a partir de Dados Cadastrais em Meu Viva',
    },
  },
  myDataPin: {
    eventType: 'action',
    screenName: 'meus_dados',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => `salvar_pin_${param}`,
    target: ['roxcode'],
    otherData: {
      description: 'Salvou alterações no uso de pin',
    },
  },
  myDataPlate: {
    eventType: 'action',
    screenName: 'meus_dados',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'salvar_placa',
    target: ['roxcode'],
    otherData: {
      description: 'Salvou alterações, com placa',
    },
  },
  myDataAddPlate: {
    eventType: 'action',
    screenName: 'meus_dados',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'placa_adicional',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou para inserir placa adicional',
    },
  },
  searchNav: {
    eventType: 'navigation',
    screenName: 'busca',
    actionType: 'segue',
    eventDate: new Date(),
    parameter: 'busca_inicio',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu Busca de qualquer lugar do Viva pela navigation bar inferior',
    },
  },
  searchText: {
    eventType: 'action',
    screenName: 'busca',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => `busca_${param}`,
    target: ['roxcode'],
    otherData: {
      description: 'Colocou texto para buscar',
    },
  },
  searchResult: {
    eventType: 'action',
    screenName: 'busca',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'busca_resultado',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu o item sugerido no resultado da busca',
    },
  },
  searchShortcut: {
    eventType: 'action',
    screenName: 'busca',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'busca_atalhos',
    target: ['roxcode'],
    otherData: {
      description: 'Abriu o item sugerido em Ações rápidas',
    },
  },
  searchRecently: {
    eventType: 'action',
    screenName: 'busca',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => `busca_recentes_${param}`,
    target: ['roxcode'],
    otherData: {
      description: 'Abriu o item sugerido em Recentes',
    },
  },
  searchPopular: {
    eventType: 'action',
    screenName: 'busca',
    actionType: 'click',
    eventDate: new Date(),
    parameter: (param: string) => `busca_populares_${param}`,
    target: ['roxcode'],
    otherData: {
      description: 'Abriu o item sugerido em Buscas Populares',
    },
  },
  termsModal: {
    eventType: 'navigation',
    screenName: 'termos_de_uso',
    actionType: 'modal',
    eventDate: new Date(),
    parameter: 'termos_inicio',
    target: ['roxcode'],
    otherData: {
      description: 'Apareceu modal Termos De Uso',
    },
  },
  termsRead: {
    eventType: 'action',
    screenName: 'termos_de_uso',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'termos_leitura',
    target: ['roxcode'],
    otherData: {
      description: 'Leu Termos De Uso',
    },
  },
  termsAccept: {
    eventType: 'action',
    screenName: 'termos_de_uso',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'termos_sucesso',
    target: ['roxcode'],
    otherData: {
      description: 'Aceitou Termos De Uso',
    },
  },
  missionCarPlateCompleted: {
    eventType: '',
    screenName: '',
    actionType: '',
    eventDate: new Date(),
    parameter: '',
    otherData: new Date(),
    target: ['roxcode'],
  },
  missionQuizCompleted: {
    eventType: '',
    screenName: '',
    actionType: '',
    eventDate: new Date(),
    parameter: '',
    otherData: {
      description: '',
    },
    target: undefined,
  },
  missionCheckIn: {
    eventType: '',
    screenName: '',
    actionType: '',
    eventDate: new Date(),
    parameter: '',
    otherData: {
      description: '',
    },
    target: undefined,
  },
  compassGeolocation: {
    eventType: 'action',
    screenName: 'mission_check_in',
    actionType: 'compass_geolocation',
    eventDate: new Date(),
    parameter: 'compassGeolocation',
    otherData: {
      description: 'Parâmetros de localização recebidos no check-in',
    },
    target: ['roxcode'],
  },
  userUpdate: {
    eventType: '',
    screenName: '',
    actionType: '',
    eventDate: new Date(),
    parameter: '',
    otherData: {
      description: '',
    },
    target: undefined,
  },
  userDelete: {
    eventType: '',
    screenName: '',
    actionType: '',
    eventDate: new Date(),
    parameter: '',
    otherData: {
      description: '',
    },
    target: undefined,
  },
  helpContactWhatsapp: {
    eventType: '',
    screenName: '',
    actionType: '',
    eventDate: new Date(),
    parameter: '',
    otherData: {
      description: '',
    },
    target: undefined,
  },
  pointDetailsMyTrades: {
    eventType: 'action',
    screenName: 'home',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'VivaPointDetailsToMyTrades',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou no botão de "Minhas Trocas" no detalhe de pontos',
    },
  },
  pointDetailsBenefitsList: {
    eventType: 'action',
    screenName: 'home',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'VivaPointDetailsToMyTrades',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou no botão de "Explorar Benefícios" no detalhe de pontos'
    },
  },
  pointDetailsAboutNotes: {
    eventType: 'action',
    screenName: 'home',
    actionType: 'click',
    eventDate: new Date(),
    parameter: 'VivaPointDetailsToMyTrades',
    target: ['roxcode'],
    otherData: {
      description: 'Tocou no botão de "Acessar Regras de Notas" no detalhe de pontos'
    },
  },
};

export const benefitsPathsArray = [
  '/benefits/promotions',
  '/benefits/events',
  '/benefits/experiences',
  '/benefits/products',
  '/benefits/coupons',
  '/benefits/collectibles',
];

export const benefitsPathDict: Record<string, string> = {
  '/benefits/promotions': 'promocao',
  '/benefits/events': 'evento',
  '/benefits/experiences': 'experiencia',
  '/benefits/products': 'produto',
  '/benefits/coupons': 'cupom',
  '/benefits/collectibles': 'colecionavel',
};
